import gql from "graphql-tag"

const fullBasketBreakdown = gql`
  fragment fullBasketBreakdown on BasketTotalWithBreakDown {
    items {
      item {
        openValue
        amount
        count
        entityId
        entityType
        productId
        targetUserId
      }
      total {
        discountPercentage
        discountPercentageAfterServiceCharge
        originalPrice
        amount
        serviceCharge
        vat
        currency
      }
    }
    total {
      discountPercentage
      discountPercentageAfterServiceCharge
      originalPrice
      amount
      serviceCharge
      vat
      currency
    }
    cashback {
      amount
      currency
    }
  }
`

export default fullBasketBreakdown
